import type { FaireProductEntity } from "../../entity_types/product";

export const p_res5ac72sj: FaireProductEntity = {
  token: "p_res5ac72sj",
  type: "product",
  name: "Big Heart Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4f41252b37d44154252dce2857b0a303419ebe280fb6e70a663b1055a50cc091.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/18e69b6aa9324ab1a258690f7eead1650d906098bb0ba030ca93bde5b2dadd11.jpeg",
    "https://cdn.faire.com/fastly/4f56efe2290831a68507a4fc5b9143c57635d33d4e810aa8ab4312bb84821a00.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:31.778Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
